import React from 'react';

export default function TabPanel({ classes, children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && <div className={classes.superAdminInfoBlock}>{children}</div>}
    </div>
  );
}
